module.exports = __webpack_public_path__ + "img/54_2.d5e6e2c4.png";